import { render, staticRenderFns } from "./ArticleHotIndexDesktopCard.vue?vue&type=template&id=3ba73bc8&"
import script from "./ArticleHotIndexDesktopCard.vue?vue&type=script&lang=js&"
export * from "./ArticleHotIndexDesktopCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports